import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=4f30ff52&scoped=true&"
import script from "./PostEditor.vue?vue&type=script&lang=js&"
export * from "./PostEditor.vue?vue&type=script&lang=js&"
import style0 from "./PostEditor.vue?vue&type=style&index=0&id=4f30ff52&lang=scss&scoped=true&"
import style1 from "./PostEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30ff52",
  null
  
)

export default component.exports